'use client';

import { useGetUserInvitesQuery } from '@/features/workspaces/api/workspacesApi';
import {
  ArchivedWorkspacesTable,
  InvitationsTable,
  PossibleWorkspacesTable,
} from '@/features/workspaces/components/workspace-select';
import { useCanWorkspaceAction } from '@/features/workspaces/hooks';
import { EmptyState } from '@web/ui';

import styles from './WorkspaceDiscoverySection.module.scss';

export function WorkspaceDiscoverySection() {
  const canReactivateArchivedWorkspace = useCanWorkspaceAction(
    'plan_management',
    'edit',
  );
  const { data: response, isLoading } = useGetUserInvitesQuery();

  const data = response?.success === true ? response.data : null;
  const archivedWorkspaces = data?.archived_workspaces ?? [];
  const reactivatableArchivedWorkspaces = canReactivateArchivedWorkspace
    ? archivedWorkspaces.filter((workspace) => workspace.can_reactivate)
    : [];
  const invitations = data?.invitations ?? [];
  const possibleWorkspaces = data?.possible_workspaces ?? [];
  const hasAnyRows =
    reactivatableArchivedWorkspaces.length > 0 ||
    invitations.length > 0 ||
    possibleWorkspaces.length > 0;

  if (!isLoading && !hasAnyRows) {
    return null;
  }

  return (
    <section
      className={styles.workspaceDiscoverySection}
      aria-label="Available workspace actions"
    >
      <ArchivedWorkspacesTable
        items={reactivatableArchivedWorkspaces}
        canReactivate={canReactivateArchivedWorkspace}
        isLoading={isLoading}
      />
      <InvitationsTable items={invitations} isLoading={isLoading} />
      <PossibleWorkspacesTable
        items={possibleWorkspaces}
        isLoading={isLoading}
      />
      {isLoading ? null : hasAnyRows ? null : (
        <EmptyState title="No workspace actions available." />
      )}
    </section>
  );
}
